import { render, staticRenderFns } from "./FoodCategoryLabel.vue?vue&type=template&id=a200150a&scoped=true&"
import script from "./FoodCategoryLabel.vue?vue&type=script&async=true&lang=js&"
export * from "./FoodCategoryLabel.vue?vue&type=script&async=true&lang=js&"
import style0 from "./FoodCategoryLabel.vue?vue&type=style&index=0&id=a200150a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a200150a",
  null
  
)

export default component.exports